import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

import { OnSaleService } from '../../services/on-sale.service';
import { AuthService } from '../../services/auth.service';
import { DataLayerService } from '../../services/datalayer.service';

@Component({
  selector: 'app-on-sale-detail',
  templateUrl: './on-sale-detail.component.html',
  styleUrls: ['./on-sale-detail.component.scss']
})
export class OnSaleDetailComponent implements OnInit {

  onSale: any = {};

  form!: FormGroup;

  // Frame & Mount
  frame: any = {};
  mount1: any = {};
  mount2: any = {};
  mount3: any = {};

  flatDiscount =15;
  public productSubType = 'space-1';

  selectedFrameId = 0;
  framesData: any[] = [];

  // Price
  finalPrice = 0;
  salePrice = 0;

  // Size
  finalSize: any = '';
  frameWidth = 0;
  frameHeight = 0;

  // Image
  image_path = '';
  my_photos: any[] = [];
  is_image_uploaded = 0;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private onSaleService: OnSaleService,
    private authenticationService: AuthService,
    private dataLayer: DataLayerService,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({});

    this.route.params.subscribe(params => {
      if (params.id) {
        this.getOnSale(params.id);
      } else if (params.slug) {
        this.getOnSaleBySlug(params.slug);
      }
    });

    this.my_photos = JSON.parse(localStorage.getItem('my_photos') || '[]');
  }

  public onProductSubType(productSubType: string) {
    this.productSubType = productSubType;
  }

  // =========================
  // GET DATA
  // =========================
  getOnSale(id: number) {
    const user_id = this.authenticationService.currentUser?.id || 0;

    this.onSaleService.find(id, user_id).subscribe(res => {
      this.onSale = res['data'];
      this.frame = this.onSale.frame || {};
      this.mount1 = this.onSale.mount1 || {};
      this.mount2 = this.onSale.mount2 || {};
      this.mount3 = this.onSale.mount3 || {};
      this.selectedFrameId = this.frame?.id || 0;
      this.setInitialData();
      this.pushArtPromoView();
    });
  }

  getOnSaleBySlug(slug: string) {
    const user_id = this.authenticationService.currentUser?.id || 0;

    this.onSaleService.findByCaption(slug, user_id).subscribe(res => {
      this.onSale = res['data'];
      this.layoutSpaceFrames = res['data']['image_arr'];
      this.frame = this.onSale.frame || {};
      this.mount1 = this.onSale.mount1 || {};
      this.mount2 = this.onSale.mount2 || {};
      this.mount3 = this.onSale.mount3 || {};
      this.selectedFrameId = this.frame?.id || 0;
      this.setInitialData();
      this.pushArtPromoView();
    });
  }



  perSqFt=0;
  perSqFtDiscount=0;
area_covered=0;

printSizeCustomWidth=0;
printSizeCustomHeight=0;

  private pushArtPromoView(): void {
    // view_promotion now fires on click via pushSelectPromotion
  }

      setInitialData() {

    
        this.frame = this.onSale?.frame ?? {};

        this.selectedFrameId=this.frame?.id;
        console.log("framessd",this.frame)

        this.getfinalSize();

        this.mount1 = this.onSale.mount1;
        this.mount2 = this.onSale.mount2;
        this.mount3 = this.onSale.mount3;
  
        this.perSqFt = this.finalPrice = this.onSale.list_price_tax;
        this.perSqFtDiscount = this.salePrice = this.onSale.net_price_tax;
        this.area_covered = this.printSizeCustomWidth * this.printSizeCustomHeight;
      
     
    }


  // =========================
  // FRAME UPDATE
  // =========================
  updateAllFrame(frameId: number) {
    this.selectedFrameId = frameId;
    this.frame = this.framesData.find(f => f.id === frameId) || {};
    this.getfinalSize();
  }

  layoutSpaceFrames = [];
  // =========================
  // SIZE CALCULATION
  // =========================
  getfinalSize() {
    if (!this.onSale?.image_size) return;

    const arr = this.onSale.image_size.split('X');
    let w = +arr[0].trim();
    let h = +arr[1].trim();

    if (this.frame?.width_in) {
      w += this.frame.width_in * 2;
      h += this.frame.width_in * 2;
    }

    this.frameWidth = w;
    this.frameHeight = h;
    this.finalSize = `${w} X ${h}`;
  }

  // =========================
  // PRICE
  // =========================
 

  // =========================
  // WISHLIST
  // =========================
  onAddToWishList() {
    if (!this.authenticationService.currentUser) return;

    // const wishlist_id = 1;

    // const payload = {
    //   on_sale_id: this.onSale.id,
    //   wishlist_id,
    //   user_id: this.authenticationService.currentUserValue.id
    // };

    // this.wishlistItemService.add(payload).subscribe(res => {
    //   this.onSale.wishlist_item = res['data'];
    // });
  }

  onRemoveFromWishList() {
    if (!this.onSale.wishlist_item) return;
    const ids = [this.onSale.wishlist_item.id];

    // Swal.fire({
    //   title: 'Remove from wishlist?',
    //   showCancelButton: true
    // }).then(result => {
    //   if (result.isConfirmed) {
    //     this.wishlistItemService.delete(JSON.stringify(ids)).subscribe(() => {
    //       this.onSale.wishlist_item = null;
    //     });
    //   }
    // });
  }

  // =========================
  // IMAGE UPLOAD
  // =========================
  onPhotoSelect(path: string) {
    this.image_path = path;
    this.is_image_uploaded = 1;
  }

  onAddToCart() {

  }

  onShare() {

  }
}